import { render, staticRenderFns } from "./CouponRecordList.vue?vue&type=template&id=090cd918&scoped=true"
import script from "./CouponRecordList.vue?vue&type=script&lang=js"
export * from "./CouponRecordList.vue?vue&type=script&lang=js"
import style0 from "./CouponRecordList.vue?vue&type=style&index=0&id=090cd918&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090cd918",
  null
  
)

export default component.exports